import { create } from 'zustand';

interface CompareState {
  selectedIds: number[];
  /** the tenders' names, for the side dock's «Харьцуулах» list */
  labels: Record<number, string>;
  toggle: (id: number, label?: string) => void;
  clear: () => void;
  isSelected: (id: number) => boolean;
}

export const useCompareStore = create<CompareState>()((set, get) => ({
  selectedIds: [],
  labels: {},
  toggle: (id, label) =>
    set((s) => ({
      selectedIds: s.selectedIds.includes(id)
        ? s.selectedIds.filter((i) => i !== id)
        : s.selectedIds.length < 4 ? [...s.selectedIds, id] : s.selectedIds,
      labels: label ? { ...s.labels, [id]: label } : s.labels,
    })),
  clear: () => set({ selectedIds: [] }),
  isSelected: (id) => get().selectedIds.includes(id),
}));
